export default "__VITE_ASSET__Dv$Lt0_k__"